(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.factory('MessageTableService', ['$rootScope', 'Message', 'MessageService', 'Alert', MessageTableServiceFn]);

    /* service to share date between controller and directives */
    function MessageTableServiceFn($rootScope, Message, MessageService, Alert) {
        // array of messages
        var messages = [];
        var messageType = 0;

        // service worker
        var service = {
            getList: getList,
            remove: remove,
            replace: replace,
            init: init,
            save: save,
            edit: edit,
            deleteItem: deleteItem
        };

        // status of table (validation)
        service.data = {
            ok: false,
            overalltime: null
        };

        return service;

        // init the service
        function init(items, messageTypeEnum) {
            messages = [];
            service.data.ok = false;
            messageType = messageTypeEnum;

            if (items) {
                items.forEach(function (item) {
                    // new object
                    var msg = new Message(messageType);
                    msg.extend(item);
                    msg.vmIndex = messages.length;
                    messages.push(msg);
                });
            } //if

            // validate 
            validate();
        }

        // validate table 
        function validate() {
            // is invalid if any of the items in the array are invalid
            service.data.ok = !messages.some(function (item) {
                return item.vmInvalid;
            });
        } // validate

        // remove from array
        function remove(index) {
            messages.splice(index, 1);
            // validate 
            validate();
            broadcastChange();
        }

        // replace with item on index
        function replace(item, index) {
            if (index >= 0) {
                messages[index] = item;
            } //if
            // validate 
            validate();
            broadcastChange();
        }

        // is currently a row in edit mode ?
        function inEditMode() {
            return messages.some(function (item) {
                return item.vmEditable;
            });
        }

        function deleteItem(item, index) {
            // save changes to db
            if (!item.vmNew) {
                MessageService.deleteMessage(item.id).then(function (result) {
                    Alert.success("Item deleted successfully");
                    remove(index);
                });
            }
        }

        // save item -> end editing
        function save(item, index) {
            item.vmEditable = false;
            item.vmNew = false;
            // validate 
            validate();

            // save changes to db
            item.prepareForSave();

            MessageService.update(item.id, item).then(function (result) {
                Alert.success("Item updated successfully");
                var updatedItem = new Message(messageType);
                updatedItem.extend(result.data);

                replace(updatedItem, index);
            });
        }

        // edit item
        function edit(item) {
            // is another row in edit ?
            if (inEditMode() || !$rootScope.isRingfoonAdmin) {
                return;
            } //if

            // make a copy for set back 
            var original = new Message(messageType);
            original.extend(item);
            // editing modus
            item.vmEditable = true;

            // return original for restoring
            return original;
        }


        // return list
        function getList() {
            return messages;
        }

        // broadcast
        function broadcastChange() {
            $rootScope.$broadcast('messageListChanged');
        }
    }
})();